<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="3">
          <h3 class="mt-3 mb-3">Delivery Dashboard</h3>
        </b-col>
        <b-col cols="4" style="display: flex; align-items:center;">

          <b-form-input id="input-small" size="lg" type="date" v-model="search_criteria.scheduled_delivery_date"
            :disabled="search_criteria.show_history_record == 'show_history_record'"></b-form-input>
          <b-button size="lg" variant="info" @click="onSearch">
            <font-awesome-icon class="mr-1" icon="sync" />
          </b-button>
        </b-col>
      </b-row>

      <b-card class="mb-1">
        <b-row>
          <b-col cols="2" class=" pr-1">
            <b-form-select size="sm" v-model="search_criteria.route_selected"
              :options="search_tracking_route_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select size="sm" v-model="search_criteria.tier_selected" :options="tracking_tier_options" />
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
            <b-button class="btn-action" size="sm" variant="info" @click="onExport">
              Export
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-row v-if="items.length > 0" class="mt-3">
        <b-col cols="12">
          <b-table responsive small outlined striped hover :items="items" :fields="fields">
            <template v-slot:cell(product_sku)="data">
              {{ data.item.product_sku }}
            </template>
            <template v-slot:cell(product_description_en)="data">
              {{ data.item.product_description_en }}
            </template>
            <template v-slot:cell(pending_count)="data">
              <span class="dot_yellow"></span> {{ data.item.pending_count }}
            </template>
            <template v-slot:cell(in_transit_count)="data">
              <span class="dot_yellow"></span> {{ data.item.in_transit_count }}
            </template>
            <template v-slot:cell(successful_count)="data">
              <span class="dot_green"></span> {{ data.item.successful_count }}
            </template>
            <template v-slot:cell(failed_count)="data">
              <span class="dot_red"></span> {{ data.item.failed_count }}
            </template>
            <template v-slot:cell(reschedule_count)="data">
              <span class="dot_red"></span> {{ data.item.reschedule_count }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import apiService from "../services/ApiService";

const fields = [
  { key: "product_channel_sku", label: "Product SKU" },
  { key: "product_description_en", label: "Description" },
  { key: "pending_count", label: "Pending", class: "center_align" },
  { key: "in_transit_count", label: "In Transit", class: "center_align" },
  { key: "successful_count", label: "Successful", class: "center_align" },
  { key: "failed_count", label: "Failed", class: "center_align" },
  { key: "reschedule_count", label: "Reschedule", class: "center_align" },
];

export default {
  name: "RouteAllocationDashboard",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService],
  data() {
    return {
      sel_table_limit: 50,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      items: [],
      fields: fields,
      search_tracking_route_options: [{ value: null, text: "All Routes" }],
      tracking_tier_options: [
        { value: null, text: "All Tier" },
        { value: "1", text: "Tier - L1" },
        { value: "2", text: "Tier - L2" },
        { value: "3", text: "Tier - L3" },
      ],
      search_criteria: {
        route_selected: null,
        tier_selected: null,
        scheduled_delivery_date: moment().format("YYYY-MM-DD"),
      },
      history_record_option: [
        {
          value: 'show_by_date',
          text: 'Show By Date'
        },
        {
          value: 'show_history_record',
          text: 'Show History Record'
        }
      ],
    };
  },
  methods: {
    async getRouteAllocations() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      try {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "delivery_dashboard_get.php",
          data: {
            offset: this.table_offset,
            limit: this.sel_table_limit,
            search_criteria: this.search_criteria,
            client_id: this.$store.state.user_obj.client_id,
            user_id: this.$store.state.user_obj.user_id,
          },
        });

        if (response.data.status === "success") {
          this.items = response.data.product_status_summary || [];
          this.total_rows = parseInt(response.data.total_rows);
        } else {
          this.$eventHub.$emit("show_alert_message", {
            alert_message: "Failed to fetch data",
            variant: "danger",
          });
        }
      } catch (error) {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: error.message,
          variant: "danger",
        });
      }

      this.loader.hide();
    },

    onSearch() {
      this.getRouteAllocations();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getRouteAllocations();
    },

    async onExport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      try {
        let response = await this.$http({
          baseURL: `${this.API_HOST}`,
          url: "delivery_dashboard_get.php",
          method: "POST",
          data: {
            offset: 0,
            limit: 999999,
            search_criteria: this.search_criteria,
            client_id: this.$store.state.user_obj.client_id,
            user_id: this.$store.state.user_obj.user_id,
          },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "route_allocation_report.xlsx");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Export failed",
          variant: "danger",
        });
      }

      this.loader.hide();
    },
  },
  async created() {
    await this.getRouteAllocations();
    let routes_response = await this.getTrackingRoutes(
      this.$store.state.user_obj
    );
    this.search_tracking_route_options = [];
    this.search_tracking_route_options.push({
      value: null,
      text: "All Routes"
    });

    this.tracking_route_options.push({
      value: null,
      text: "-"
    });
    for (let i in routes_response.tracking_routes) {

      this.search_tracking_route_options.push({
        value: routes_response.tracking_routes[i].route_name,
        text: routes_response.tracking_routes[i].route_name
      });
    }
  },
};
</script>

<style>
.center_align {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DeliveryDashboard.vue